<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_chatbot_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body">
    <form (submit)="$event.preventDefault()">
        <div class="form-group mb-20">
            <div class="input-group">
                <div class="input-group-btn" dropdown>
                    <button dropdownToggle type="button" class="btn btn-default type-dropdown-toggle">
                        <img
                            class="element-icon mr-10"
                            src="./assets/img/websites/social-icons/{{ iconType() }}/{{ socialNetwork() }}-{{
                                iconType()
                            }}.svg"
                            alt="facebook"
                        />
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu dropdown-overflow-wrapper" *dropdownMenu>
                        @for (messenger of messengerNames(); track messenger) {
                            <li [class.selected]="messenger === socialNetwork()" (click)="setMessenger(messenger)">
                                <a>
                                    <span class="dropdown-icon mr-10">
                                        <img
                                            src="./assets/img/websites/social-icons/logos/{{ messenger }}-logos.svg"
                                            alt="facebook"
                                        />
                                    </span>
                                    {{ messenger | titlecase }}
                                </a>
                            </li>
                        }
                    </ul>
                </div>
                <input class="form-control" [value]="name()" (input)="onNameChange($event)" />
            </div>
            @if (socialNetwork() === ESocialNetworks.instagram) {
                <p class="analytic-hint small text-muted mb-0">
                    {{ "chat_bot_ig_hint" | translate }}
                    <a
                        href="https://developers.facebook.com/docs/messenger-platform/instagram/features/ig-me-links#refparams"
                        target="_blank"
                    >
                        {{ "chat_bot_see_more" | translate }}
                        <img
                            class="font-icon-light"
                            src="./assets/img/websites/lpc-new-window-icon.svg"
                            alt="new-window-icon"
                        />
                    </a>
                </p>
            }
            @if (socialNetwork() === ESocialNetworks.messenger) {
                <p class="analytic-hint small text-muted mb-0">
                    {{ "chat_bot_me_hint" | translate }}
                    <a href="https://developers.facebook.com/community/threads/1048245513262620/" target="_blank">
                        {{ "chat_bot_see_more" | translate }}
                        <img
                            class="font-icon-light"
                            src="./assets/img/websites/lpc-new-window-icon.svg"
                            alt="new-window-icon"
                        />
                    </a>
                </p>
            }
        </div>

        @if (chatBotsList()?.length > 0) {
            <div class="form-group" [class.mb-20]="!botId()" [class.mb-10]="botId()">
                <div class="form-group">
                    <label class="control-label">{{ "subscribe_to" | translate }}</label>
                    <div class="wrap-dropdown-control input-group">
                        <div class="input-group-btn" dropdown>
                            <button
                                dropdownToggle
                                type="button"
                                class="btn btn-default type-dropdown-toggle chat-bot-select"
                                [class.disabled]="isChainsLoading()"
                            >
                                @if (botName()) {
                                    <span>{{ botName() }}</span>
                                }
                                @if (!botName()) {
                                    <span>{{ "provide_link" | translate }}</span>
                                }
                                <span class="caret"></span>
                            </button>
                            <ul class="dropdown-menu dropdown-overflow-wrapper" *dropdownMenu>
                                @for (chatBot of chatBotsList(); track chatBot.id) {
                                    <li (click)="setBot(chatBot)">
                                        <a>{{ chatBot.name }}</a>
                                    </li>
                                }
                                @if (!isSubscriptionForm()) {
                                    <li><hr /></li>
                                    <li (click)="useOwnLink()">
                                        <a>{{ "provide_link" | translate }}</a>
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        }

        @if (chatBotChains$ | async; as chains) {
            @if (botId() && chains?.length) {
                <div class="help-block small">
                    <div>{{ "post_subscription_chain" | translate }}</div>
                    <span class="dropdown dropdown-chains" dropdown>
                        <a class="dotted-toggle" data-toggle="dropdown" dropdownToggle>
                            <span class="selected-chain">{{ chainName() }}</span>
                        </a>

                        <ul class="dropdown-menu dropdown-overflow-wrapper dropdown-menu-center" *dropdownMenu>
                            @for (chain of chains; track chain.chainId) {
                                <li class="padding-10" (click)="setBotChain(chain)">
                                    <a class="small text-nowrap" [title]="chain.name">
                                        {{ chain.name }}
                                    </a>
                                </li>
                            }
                        </ul>
                    </span>
                </div>
            }
        }

        @if (!botId() && !isSubscriptionForm()) {
            <div class="form-group mb-10">
                <label>{{ "control_link" | translate }}</label>
                <input
                    class="form-control"
                    [placeholder]="getPlaceholder(socialNetwork())"
                    [value]="link()"
                    (input)="onLinkChange($event)"
                />
            </div>
        }

        @if (socialNetwork() === ESocialNetworks.telegram && !botId()) {
            <div class="form-group mb-0">
                <label class="checkbox-inline">
                    <input
                        type="checkbox"
                        [checked]="preventLinkConverting()"
                        (change)="togglePreventLinkConverting($event)"
                    />
                    {{ "prevent_link_wrapping" | translate }}
                </label>
            </div>
        }
    </form>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
